/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetApplicationStatus_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly status: _Types.CreditApplicationStatus | null };

export type GetApplicationStatus_Query = { readonly __typename: 'Query', readonly creditApplication: GetApplicationStatus_creditApplication_CreditApplication | null };


export type GetApplicationStatusVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetApplicationStatus = GetApplicationStatus_Query;


export const GetApplicationStatusDocument = gql`
    query GetApplicationStatus($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    status
  }
}
    `;

/**
 * __useGetApplicationStatus__
 *
 * To run a query within a React component, call `useGetApplicationStatus` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationStatus` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationStatus({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetApplicationStatus(baseOptions: Apollo.QueryHookOptions<GetApplicationStatus, GetApplicationStatusVariables> & ({ variables: GetApplicationStatusVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationStatus, GetApplicationStatusVariables>(GetApplicationStatusDocument, options);
      }
export function useGetApplicationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationStatus, GetApplicationStatusVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationStatus, GetApplicationStatusVariables>(GetApplicationStatusDocument, options);
        }
export function useGetApplicationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationStatus, GetApplicationStatusVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApplicationStatus, GetApplicationStatusVariables>(GetApplicationStatusDocument, options);
        }
export type GetApplicationStatusHookResult = ReturnType<typeof useGetApplicationStatus>;
export type GetApplicationStatusLazyQueryHookResult = ReturnType<typeof useGetApplicationStatusLazyQuery>;
export type GetApplicationStatusSuspenseQueryHookResult = ReturnType<typeof useGetApplicationStatusSuspenseQuery>;
export type GetApplicationStatusQueryResult = Apollo.QueryResult<GetApplicationStatus, GetApplicationStatusVariables>;